/* Copyright 2013 The MathWorks, Inc. */

/**
 * This defines a mapping between the type of control and the properties associated with it.
 * A property can be marked as required and a default value can also be assigned to it.
 */

define([
    "MW/uiframework/constants/TypeConstants"
],
    function (TypeConstants) {
        return [
            TypeConstants.ROOT,
            TypeConstants.ORPHAN_ROOT,
            TypeConstants.TOOLSTRIP_ROOT,
            TypeConstants.POPUP_ROOT,
            TypeConstants.QAB_ROOT,
            "QAGroupRoot",  // Necessitated by workaround in AppContainer.m.  Should eventually be removed.

            //Gallery:
            TypeConstants.GALLERY_ROOT,
            TypeConstants.GALLERY_POPUP_ROOT,
            TypeConstants.GALLERY_PANEL_ROOT,
            TypeConstants.GALLERY_FAVORITE_CATEGORY_ROOT
        ];
    });